import React from "react";
import { process } from "../mock";
import Reveal from "./Reveal";

// Compact "How it works" section: three steps side by side.
const StickyProcess = () => {
  return (
    <section className="py-16 lg:py-24">
      <div className="max-w-6xl mx-auto px-5 lg:px-6">
        <Reveal className="text-center max-w-2xl mx-auto mb-12">
          <span className="text-[#ea731d] font-semibold tracking-widest text-xs uppercase">How it works</span>
          <h2 className="mt-3 text-3xl lg:text-5xl font-bold text-[#1a1714]">Hassle-free from day one</h2>
          <p className="mt-4 text-neutral-600 text-lg">Three simple steps from your first call to a spotless space.</p>
        </Reveal>

        <div className="relative grid md:grid-cols-3 gap-5 lg:gap-6">
          {/* connecting line on desktop */}
          <div className="hidden md:block absolute top-[46px] left-[16%] right-[16%] h-px bg-gradient-to-r from-transparent via-[#ea731d]/30 to-transparent" />

          {process.map((p, i) => {
            const Icon = p.icon;
            return (
              <Reveal key={i} delay={i * 110}>
                <div
                  data-testid={`process-step-${i}`}
                  className="relative h-full bg-white rounded-[24px] p-7 border border-neutral-200/70 soft-shadow transition-all duration-300 hover:-translate-y-1"
                >
                  <div className="flex items-center justify-between">
                    <span className="w-14 h-14 rounded-2xl bg-[#ea731d] text-white flex items-center justify-center relative z-10">
                      <Icon size={26} />
                    </span>
                    <span className="font-display text-5xl font-bold text-[#ea731d]/15 leading-none">{p.step}</span>
                  </div>
                  <h3 className="mt-6 text-xl lg:text-2xl font-bold text-[#1a1714]">{p.title}</h3>
                  <p className="mt-2.5 text-neutral-600 leading-relaxed">{p.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StickyProcess;
